module.exports = __webpack_public_path__ + "img/4.7dfd1de1.jpg";